import SmartAnchorPanel from "@/components/SmartAnchorPanel";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { Modal, Spin } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import AutoMergeSetting from "./AutoMergeSetting";
import { useRequest } from "ahooks";
import { useGlobalStore } from "@/store/hooks";
import PrintingSetting from "./PrintingSetting";
import OrderSetting from "./OrderSetting";
import AbnormalOrderSetting from "./AbnormalOrderSetting";
import TipModalSetting from "./TipModalSetting";

interface ShopAdvancedSettingModalProps extends InjectBaseModalProps {
    shopId: number;
}

const ShopAdvancedSettingModal: React.FC<ShopAdvancedSettingModalProps> = function (props) {
    const { open, onCancel, shopId } = props;
    const globalStore = useGlobalStore();

    const { loading: loading1, data: shopSetting } = useRequest(async () => {
        await globalStore.getShopSetting([shopId]);

        return globalStore.shopSettingMapping.get(shopId);
    });

    const { loading: loading2, data: shopAdvancedSetting } = useRequest(async () => {
        return await globalStore.shopAdvancedSettingStore.getAdvancedSetting(shopId);
    });

    const loading = loading1 || loading2;

    return (
        <Modal open={open} onCancel={onCancel} title="高级设置" footer={null} width={1050}>
            <Spin spinning={loading}>
                <SmartAnchorPanel
                    maxHeight={750}
                    anchorItems={
                        shopSetting && shopAdvancedSetting
                            ? [
                                  {
                                      id: "auto_merge_setting",
                                      title: "合并设置",
                                      content: (
                                          <AutoMergeSetting
                                              shopAdvancedSetting={shopAdvancedSetting}
                                              shopSetting={shopSetting}
                                          />
                                      ),
                                  },
                                  {
                                      id: "printing_setting",
                                      title: "打印设置",
                                      content: (
                                          <PrintingSetting
                                              shopAdvancedSetting={shopAdvancedSetting}
                                              shopSetting={shopSetting}
                                          />
                                      ),
                                  },
                                  {
                                      id: "order_setting",
                                      title: "订单设置",
                                      content: (
                                          <OrderSetting
                                              shopAdvancedSetting={shopAdvancedSetting}
                                              shopSetting={shopSetting}
                                          />
                                      ),
                                  },
                                  {
                                      id: "abnormal_order_setting",
                                      title: "异常检测设置",
                                      content: (
                                          <AbnormalOrderSetting
                                              shopAdvancedSetting={shopAdvancedSetting}
                                              shopSetting={shopSetting}
                                          />
                                      ),
                                  },
                                  {
                                      id: "tip_modal_setting",
                                      title: "打印发货页面弹窗设置",
                                      content: (
                                          <TipModalSetting
                                              shopAdvancedSetting={shopAdvancedSetting}
                                              shopSetting={shopSetting}
                                          />
                                      ),
                                  },
                              ].filter(Boolean)
                            : null
                    }
                />
            </Spin>
        </Modal>
    );
};

export default observer(ShopAdvancedSettingModal);
